import React, { useEffect, useState } from "react"
import hy from 'date-fns/locale/hy';
import { format, formatDate } from 'date-fns';
import { axiosInstance } from "../../Helpers/axiosInstance";
import AccidentItem from "../Accident/AccidentItem";
import AccidentUnitModal from "../../Modals/Accident/AccidentUnitModal";

                 
const AccidentUnitInfo = ({unit, added, unitList, closeModal, setAdded }) => { 
    const [info, setInfo] = useState([])
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [idx, setIdx] = useState(null)

    const fetchData = async () => {
            try {
                if(unit){
                    const response = await axiosInstance.get(`/admin/unit-accident/${unit?._id}`)
                    if(!response.data.status) {
                        console.error("Failed to fetch firing info")
                        return
                    }
                    setInfo(response.data.data)
                }
            } catch (error) {
                console.error("Error fetching firing info:", error)
            }
        }

    useEffect(() => {
        fetchData()
    }, [unit._id])

       useEffect(() => {
        if(added){
            fetchData()
        }
    }, [added])


    const deleteInfo = async(id) => {
        try{
            const response = await axiosInstance.delete(`/admin/unit-accident/${unit._id}/${id}`)
            if(!response.data.status) {
                console.error("Failed to delete firing info")
                return
            }
            setInfo(response.data.data)
        }catch(error){
            console.log('error', error)
        }
    }

    return (
        <div className="" onClick={(e) => e.stopPropagation()}>
           { info && info.sort((a,b) => a.date > b.date ? -1 : 1).map((item, index) => {
                   return (
                       <AccidentItem item={item} index={index} deleteInfo={deleteInfo} key={index} setIdx={setIdx} setIsOpenModal={setIsOpenModal} />
                   )
           })}

        {isOpenModal && <AccidentUnitModal unitList={unitList} fetchInfo={fetchData} item={info[idx]} currentUnit={unit} closeModal={() => {closeModal(); setIsOpenModal(false)}} setAdded={setAdded} />}
        </div>
    )
}


export default AccidentUnitInfo